import styled from 'styled-components';
import { RalewayFont } from 'constants/fonts';
import { black } from 'constants/colors';

export const SpeedDatingCardWrapper = styled.div`
  display: inline-block;
  vertical-align: top;
  background-color: #fff;
  width: 15rem;
  margin-right: 1rem;
  border-radius: 1.5rem;
  cursor: pointer;
  white-space: normal;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
  border: 0.1rem solid #e9e9e9;

  .header {
    padding: 1rem;
    .section_name {
      font-size: 1.1rem;
      margin-bottom: 0.5rem;
    }
    .title {
      font-family: ${RalewayFont.boldFamily};
      font-size: 1.6rem;
      color: ${black};
      overflow: hidden;
      height: 1.7rem;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .banner_speed_dating {
    height: 9.4rem;
    text-align: center;
    display: grid;
    grid-template-rows: 1fr;
    align-items: start;
    justify-items: center;
    background-size: cover;
    background-position: 50% 50%;
    font-size: 1.7rem;
    text-align: left;
    padding: 1rem;
    line-height: 2rem;
    color: #fff;
  }

  &.disabled {
    .header {
      filter: grayscale(100%);
    }

    .banner_narrative {
      filter: grayscale(100%);
    }
  }

  .description {
    padding: 1rem;
    font-family: ${RalewayFont.regularFamily};
    font-size: 1.3rem;
    color: ${black};
    overflow: hidden;
    height: 6rem;
    line-height: 1.7rem;
    margin-bottom: 1rem;

    .user_img {
      font-size: 1.1rem;
      width: 2.2rem;
      display: inline-block;
      vertical-align: top;
    }

    .user_data {
      font-size: 1.1rem;
      line-height: 1.2rem;
      width: calc(100% - 2.2rem);
      display: inline-block;
      vertical-align: top;
      color: ${black};
    }
  }

  .footer {
    white-space: nowrap;
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Cards/SpeedDatingSmallCard/components/styles.js